import { ToggleButton, ToggleButtonGroup } from "@material-ui/lab";

const { withStyles } = require("@material-ui/core");

export const StyledToggleButtonGroup = withStyles((theme) => ({
  root: {
    boxShadow: "none",
    borderRadius: 0,
  },
}))(ToggleButtonGroup);

export const StyledToggleButton = withStyles((theme) => ({
  root: {
    boxShadow: "none",
    borderRadius: 0,
    color: "#212121",
    fontWeight: "bolder"
  },
  selected: {
    backgroundColor: "#2196F3 !important",
    color: "#FFFFFF !important",
    borderColor: "#2196F3",
    fontWeight: "normal"
  },
  label: {
    textTransform: "capitalize",
    fontSize: 14,
  },
}))(ToggleButton);
